// extracted by mini-css-extract-plugin
export default {"fullWidthButton":"_AutomationTemplateInfo_fullWidthButton__fdJbQ"};